<template>
  <div>
    <lerner-header :show-login-form="false"></lerner-header>
    <div class="flex pb-5">
      <div class="col-2 mx-1"></div>
      <div class="col-8 mx-1 py-5 text-center">
        <slot name="image"></slot>
        <h3 class="text-lerner-orange">{{ headline }}</h3>
        <div class="my-4">
          <hr class="bg-lerner-orange h-1"/>
        </div>
        <div class="body-7 pt-3 pb-5">
          <slot name="message"></slot>
        </div>
        <button v-on:click="returnToHome" class="body-8">Return to Home </button>
      </div>
      <div class="col-2 mx-1"></div>
    </div>
  </div>
</template>

<script>
  import LernerHeader from '@/component/Header';

  export default {
    name: 'Error',

    props: ['headline'],

    components: {
      LernerHeader
    },

    methods: {
      returnToHome() {
        this.$router.push({name: 'home'});
      }
    }
  };
</script>

<style lang="scss" scoped>
  img {
    max-width: 250px;
    max-height: 250px;
    @apply my-6;
  }

  button {
    @apply bg-lerner-blue text-white font-bold py-2 px-8 rounded-full;

    &:hover {
      background: lighten(#2d4c90, 10%);
    }
  }
</style>
